import { EXPLORE_BASE_SPLUNK_EVENT } from 'features/explore/constants';
import { useCallback } from 'react';
import { useSplunkCallback } from 'hooks/use-splunk-callback/use-splunk-callback';
import { openMarketReport, OpenMarketReportParams } from 'utils/navigation/navigation';

type OpenMarketReportViaExplore = OpenMarketReportParams & { splunkComponentId?: string };
export const useOpenMarketReportViaExplore = () => {
    const baseSplunkEventData = {
        ...EXPLORE_BASE_SPLUNK_EVENT,
    };
    const sendSplunkEvent = useSplunkCallback(baseSplunkEventData);

    return useCallback(
        ({ splunkComponentId, ...rest }: OpenMarketReportViaExplore) => {
            sendSplunkEvent({
                component: splunkComponentId,
                action: 'open report',
                value: 'Market',
            });

            openMarketReport(rest);
        },
        [sendSplunkEvent],
    );
};
